/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice\src\Content\Car\CarListRow\CarListRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice
 * Created Date: Friday September 20th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday September 20th 2024 10:03:24 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import RouterPathResolver from "Config/Router/RouterPathResolver";
import CarCard from "Content/CarCard/CarCard";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "Router/AuthProvider";
import CarService from "Services/Car/CarService";
import ServiceGeneral from "Services/ServiceGeneral";
import { CarType } from "Type/Car.type";
import Styles from "Content/Car/CarListRow/CarList.module.css";
import { CarInSell } from "Type/CarElement.type.hold";

type CarListRowProps = {
    Status: string,
    FilteredCars: CarInSell[] | null
}

export default function CarListRow(props: CarListRowProps) {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const [cars, setCars] = useState([]);
    const convertIdx: {[key: string]: number} = {
        "RESERVED": 0,
        "SOLD": 1,
        "SELLING": 2
    };

    useEffect(() => {
        if (props.FilteredCars) {
            setCars((props.FilteredCars) as SetStateAction<never[]>);
        } else {
            ServiceGeneral.manageAxiosResponse(() => { return CarService.getCarList({perpage: 999, status: props.Status})}, () => logout()).then((result) => {
                const tmp = result.cars.sort((a: {InSell: {Status: string}[]}, b: {InSell: {Status: string}[]}) => {return convertIdx[a.InSell[0].Status] - convertIdx[b.InSell[0].Status]});
                setCars(tmp);
            });
        }
    }, [props.FilteredCars]);

    const handleClickCar = (id: string, editable: boolean) => {
        navigate(`${RouterPathResolver.pathCar_BY_ID.path.replace(":id", id)}`+`${editable ? "?editable=true" : ""}`);
    };

    const buildMyRows = (Car: CarType[]) => {
        let myRows: JSX.Element[] = [];
        for (let i = 0; i < Car.length; ++i) {
            myRows.push(
                <div key={`sell-${Car[i].RegNb}`} className={`${Styles.carCard}`} >
                    <CarCard handleNavigation={handleClickCar} car={{...Car[i], SeenCar: Car[i].SeenCar}} />
                </div>
            );
        }
        return myRows;
    };

    const carRows = useMemo<JSX.Element[]>(
        () => buildMyRows(cars), [cars]
    );

    return (
        <div className={`${Styles.carCardHolder}`}>
            {carRows}
        </div>
    );
};
